import axios from "axios";

export default {
  /*check() {
        return axios.post('/api/auth/check').then(response => {
            return response
        }).catch(error => {
            return error.response
        })
    },*/
  checkIsAdmin() {
    return axios
      .post("/api/auth/check")
      .then(response => {
        //localStorage.setItem('token', response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  refresh() {
    const user = JSON.parse(localStorage.getItem("dec"));
    if (user["auth"]["account"]["id"]) {
      return axios
        .get("/api/candidate/show/" + user["auth"]["account"]["id"])
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("dec");
    }
  },
  login(loginData) {
    return axios
      .post("/api/auth/login", loginData)
      .then(response => {
        localStorage.setItem("token", response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  register(registerData) {
    return axios
      .post("/api/auth/signup", registerData)
      .then(response => {
        localStorage.setItem("token", response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response.data;
      });
  },
  shopRegister(registerData) {
    return axios
      .post("/api/auth/shop_signup", registerData)
      .then(response => {
        localStorage.setItem("token", response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response.data;
      });
  },
  jpoRegister(registerData) {
    return axios
      .post("/api/auth/jpo_signup", registerData)
      .then(response => {
        //localStorage.setItem("token", response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response.data;
      });
  },
  atelierRegister(registerData) {
    return axios
      .post("/api/auth/atelier_signup", registerData)
      .then(response => {
        //localStorage.setItem("token", response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response.data;
      });
  },
    webinaireRegister(registerData) {
        return axios
            .post("/api/auth/webinaire_signup", registerData)
            .then(response => {
                //localStorage.setItem("token", response.data.meta.token);
                return response;
            })
            .catch(error => {
                return error.response.data;
            });
    },
  contactRegister(registerData) {
    return axios
      .post("/api/auth/contact_signup", registerData)
      .then(response => {
        //localStorage.setItem("token", response.data.meta.token);
        return response;
      })
      .catch(error => {
        return error.response.data;
      });
  },
  liveRegister(registerData) {
    return axios
        .post("/api/auth/live_signup", registerData)
        .then(response => {
          //localStorage.setItem("token", response.data.meta.token);
          return response;
        })
        .catch(error => {
          return error.response.data;
        });
  },
  docRegister(registerData) {
    return axios
        .post("/api/auth/doc_signup", registerData)
        .then(response => {
          //localStorage.setItem("token", response.data.meta.token);
          return response;
        })
        .catch(error => {
          return error.response.data;
        });
  },
  adminRegister(registerData) {
    return axios
      .post("/api/auth/admin_signup", registerData)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response.data;
      });
  },
  lostPassword(email) {
    return axios
      .post("/api/auth/recover", email)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  resetPassword(resetData) {
    return axios
      .post("/api/auth/reset", resetData)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  logout() {
    return axios
      .post("/api/auth/logout")
      .then(response => {
        localStorage.removeItem("token");
        localStorage.removeItem("dec");
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  saveAccount(accountData) {
    return axios
      .post("/api/candidate/update", accountData)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  updateAccount(accountData) {
    return axios
      .post("/api/account/update", accountData)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  }
};
